"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Format to locale string and remove decimals, e.g. 1234.56 => 1,235
function formatAndDropDecimal(v) {
    return v.toLocaleString(undefined, { maximumFractionDigits: 0 });
}
exports.default = formatAndDropDecimal;
//# sourceMappingURL=formatAndDropDecimal.js.map